function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
var layersHaveMetadata = function layersHaveMetadata() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return layers.some(function (l) {
    return !!l.getMetadataIdentifier();
  });
};
var layersHaveMultipleStyles = function layersHaveMultipleStyles() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return layers.some(function (l) {
    return l.getStyles().length > 1;
  });
};
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(tool) {
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this.tool = tool;
    _this.sandbox = tool.getSandbox();
    var layers = _this.sandbox.findAllSelectedMapLayers();
    _this.setState({
      baseLayers: [],
      defaultBaseLayer: null,
      showMetadata: false,
      isStyleSelectable: false,
      isDisabledMetadata: !layersHaveMetadata(layers),
      isDisabledStyleChange: !layersHaveMultipleStyles(layers)
    });
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "init",
    value: function init(pluginConfig) {
      this.updateState(_objectSpread({}, pluginConfig));
    }
  }, {
    key: "clearState",
    value: function clearState() {
      // plugin is created again on startup, so it's state doesn't need to be cleare
      var layers = this.sandbox.findAllSelectedMapLayers();
      this.setState({
        baseLayers: [],
        defaultBaseLayer: null,
        showMetadata: false,
        isStyleSelectable: false,
        isDisabledMetadata: !layersHaveMetadata(layers),
        isDisabledStyleChange: !layersHaveMultipleStyles(layers)
      });
    }
  }, {
    key: "onLayersChanged",
    value: function onLayersChanged() {
      var layers = this.sandbox.findAllSelectedMapLayers();
      // update state with checks if layers now/still have metadata/multiple styles
      this.updateState({
        isDisabledMetadata: !layersHaveMetadata(layers),
        isDisabledStyleChange: !layersHaveMultipleStyles(layers)
      });
    }
  }, {
    key: "setShowMetadata",
    value: function setShowMetadata(value) {
      this.tool.getPlugin().setShowMetadata(value);
      this.updateConfig2State();
    }
  }, {
    key: "setAllowStyleChange",
    value: function setAllowStyleChange(value) {
      this.tool.getPlugin().setStyleSelectable(value);
      this.updateConfig2State();
    }
  }, {
    key: "addBaseLayer",
    value: function addBaseLayer(layer) {
      this.tool.getPlugin().addBaseLayer(layer);
      this.updateConfig2State();
    }
  }, {
    key: "removeBaseLayer",
    value: function removeBaseLayer(layer) {
      this.tool.getPlugin().removeBaseLayer(layer);
      this.updateConfig2State();
    }
  }, {
    key: "updateConfig2State",
    value: function updateConfig2State() {
      var _this$tool;
      var newConfig = ((_this$tool = this.tool) === null || _this$tool === void 0 || (_this$tool = _this$tool.getPlugin()) === null || _this$tool === void 0 ? void 0 : _this$tool.getConfig()) || {};
      this.updateState(_objectSpread({}, newConfig));
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(UIHandler, ['setShowMetadata', 'setAllowStyleChange', 'addBaseLayer', 'removeBaseLayer']);
export { wrapped as MapLayerListHandler };